import React from 'react'
import CollectionWidgetManager from 'src/services/collections.widget.service';
import TinyMCE from 'react-tinymce/lib/components/TinyMCE';

import cx from 'classnames';
import styles from './editor.module.scss';
import _ from 'lodash';


interface IDescriptionEditor {
  content : string;
  onChange : (value : string) => void;
  widgetManager: CollectionWidgetManager;
  rephrasing?: any;
  className?: string;
  outputFormat?: string;
  tones?: any;
  placeholder?: string;
  setLimitReached: (value: boolean) => void;
}

const DescriptionEditor:React.FC<IDescriptionEditor> = ({ content, onChange, widgetManager, tones, className, outputFormat = 'text', placeholder = "Type your description here...", setLimitReached }) => {
  const linkLength = 100
  const [initialized, setInitialized] = React.useState(false);
  const description = React.useMemo(() => {
    let processedContent = content.replace(/\n/g, "<br/>")
    processedContent = processedContent.replaceAll(`{link}`, `<span class="variable mceNonEditable" style="text-decoration:underline" contenteditable="false" data-original-variable="{{asset.link}}"> {link} </span>`);
      processedContent = '<div>' + processedContent + '</div>';
      return processedContent;
    }, [tones]);
  const variables = [
    {
      id: 'asset.link',
      name: ` {link} `,
      type: 'variable',
      getValue: (parameters) => {
        return parameters['asset.link'];
      }  
    }
  ]
const editorRef = React.useRef<any>(null);
const isLinkAppended = (content) => {
  return content.includes(`{link}`);
}

const decodeHTMLEntities = (text) => {
  const doc = new DOMParser().parseFromString(text, "text/html");
  return doc.body.textContent || "";
};

const validateContent = (content) => {
  const processedContent = content.replaceAll(`{link}`,'');
  let processedContentLength = processedContent.length;
  const maxLength = 2900;
  if(isLinkAppended(content)) {
    const noOfLinksAttached = content.match(/{link}/g).length;
    processedContentLength = processedContentLength + (noOfLinksAttached * linkLength)
  }
  if (processedContentLength > maxLength) {
    setLimitReached(true);
  } 
  else {
    setLimitReached(false);
  }
}
  return (
    <>
  {!initialized &&
        <style>
          {`
            .tox-tinymce-inline {
              display: none !important;
              opacity: 0;
            }
          `}
        </style>
      }
  <TinyMCE
  content={description}
  className={cx(styles.tinyEditor,className)}
  config={{
    placeholder: placeholder,
    inline: true,
    branding: false,
    statusbar: false,
    contextmenu: false,
    theme: 'silver',
    plugins: 'code, autoresize, noneditable, variable, paste, link, autolink, lists',
    menubar: false,
    toolbar: 'undo redo | asset_link',
    fontsize_formats: '5px 5.5px 6.5px 7.5px 8px 9px 10px 10.5px 11px 12px 14px 16px 18px 20px 22px 24px 26px 28px 36px 48px 72px',
    paste_retain_style_properties: "color",
    resize: false,
    height: 120,
    content_css: [
      'https://fonts.googleapis.com/css?family=Montserrat:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i'
    ],
    default_link_target: "_blank",
    browser_spellcheck: true,
    convert_urls: false,
    relative_urls: false,
    remove_script_host: false,
    forced_root_block: '',
    force_br_newlines: true,
    force_p_newlines: false,
    variable_mapper: (id) => {
      const variable = variables.find((item) => {
        return item.id == id;
      });

      if (variable) {
        return variable.name;
      }
    },
    variable_valid: ['asset.link'],
    setup: (editor) => {
      editorRef.current = editor;
      editor.on('PostRender', () => {
        setTimeout(() => {
          editor.ui.hide();
          setInitialized(true);
        }, 300);
      });
      editor.on('keyup', (e) => {
        const content = editor.getContent({ format: 'text' });
        validateContent(content);
      });
      editor.ui.registry.addButton("asset_link", {
        text: "Insert Asset Link",
        onAction: () => {
          editor.plugins.variable.addVariable('asset.link');
          validateContent(editor.getContent({ format: 'text' }));
        }
      });
    }
  }}
  onChange={(e:any) => {
    const template = decodeHTMLEntities(widgetManager.getRawTemplate(e.target.getContent({format: outputFormat})));
    onChange(template);
  }}
  />
  </>
  )
}

export default DescriptionEditor